import { render, staticRenderFns } from "./ContentTypeManager.vue?vue&type=template&id=f02bbf72&scoped=true"
import script from "./ContentTypeManager.vue?vue&type=script&lang=js"
export * from "./ContentTypeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02bbf72",
  null
  
)

export default component.exports